<app-error>
  <div class="description">{{ 'general.unlicensed' | translate }}</div>
  <div class="description">
    {{ 'general.unlicensedDescription' | translate }}
  </div>
</app-error>
